import { ProjectUser } from '@monorepo/shared/apiClient/types';
import { MenuOption } from '@monorepo/shared/componentsV2/menus/Menu';
import {
  isOrgAdmin,
  isPrimarySiteAdmin,
  NO_PERMISSION_TOOLTIP,
} from './sharedUtils';

const ORG_ADMIN_REMOVE_TOOLTIP =
  'This user is an organization admin, so they cannot be removed from individual sites';

const PRIMARY_ADMIN_REMOVE_TOOLTIP =
  'Another user must be designated the primary site admin in order to remove this user';

const SELF_REMOVE_TOOLTIP = 'You cannot remove yourself from a site.';

type RemoveFromSiteActionParams = {
  user: ProjectUser;
  isSelf: boolean;
  canManageUsers: boolean;
  onRemove: () => void;
};

export function getRemoveFromSiteAction({
  user,
  isSelf,
  canManageUsers,
  onRemove,
}: RemoveFromSiteActionParams): MenuOption {
  const getDisabledTooltip = () => {
    if (!canManageUsers) return NO_PERMISSION_TOOLTIP;
    if (isSelf) return SELF_REMOVE_TOOLTIP;
    if (isOrgAdmin(user)) return ORG_ADMIN_REMOVE_TOOLTIP;
    if (isPrimarySiteAdmin(user)) return PRIMARY_ADMIN_REMOVE_TOOLTIP;
    return '';
  };

  const disabledTooltip = getDisabledTooltip();

  return {
    displayName: 'Remove from site',
    onClick: onRemove,
    disabled: !!disabledTooltip,
    tooltip: disabledTooltip,
    color: 'danger',
  };
}
